import { render } from "./CommonEmptyState.vue?vue&type=template&id=74d06d4e"
import script from "./CommonEmptyState.vue?vue&type=script&lang=js"
export * from "./CommonEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__